class GoChatLocalization extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.observers = new Map();
    this.waitingForRuntime = false;
    const refresh = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.localize());
    };
    for (const event of ['shopify-chat:close', 'shopify-chat:enter-standalone', 'shopify-chat:enter-managed']) {
      document.addEventListener(event, refresh, { signal: this.controller.signal });
    }
    customElements.whenDefined('shopify-chat').then(() => {
      if (!this.isConnected) return;
      refresh();
      this.timeout = setTimeout(() => this.stopWatching(), 15000);
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    cancelAnimationFrame(this.frame);
    clearTimeout(this.timeout);
    this.stopWatching();
  }

  stopWatching() {
    this.observers?.forEach((observer) => observer.disconnect());
    this.observers?.clear();
  }

  watch(root) {
    if (!root || this.observers.has(root)) return;
    const observer = new MutationObserver(() => this.localize());
    this.observers.set(root, observer);
    observer.observe(root, { childList: true, subtree: true });
  }

  localize() {
    if (!this.isConnected) return;
    const chat = document.querySelector('#chat-drawer shopify-chat');
    this.watch(chat?.shadowRoot);
    const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
    if (!runtime) return;
    this.watch(runtime.shadowRoot);
    if (!runtime.shadowRoot && !this.waitingForRuntime) {
      this.waitingForRuntime = true;
      customElements.whenDefined(runtime.localName).then(() => {
        if (this.isConnected) requestAnimationFrame(() => this.localize());
      });
    }
    const button = runtime.shadowRoot?.querySelector('button[part~="activator"]');
    if (!button) return;
    const label = button.querySelector('.activator__label');
    if (label?.textContent.trim() === 'Chat') label.textContent = this.dataset.launcher;
    if (button.getAttribute('aria-label') === 'Chat') button.setAttribute('aria-label', this.dataset.launcher);
    this.stopWatching();
    clearTimeout(this.timeout);
  }
}

if (!customElements.get('go-chat-localization')) {
  customElements.define('go-chat-localization', GoChatLocalization);
}
